import React, { useEffect, useState } from 'react';
import * as S from './estilos';

import useData from '../../Utils/useData/index';
import ReactHtmlParser from 'react-html-parser';
import Load from '../Load';

import ImgRiscoVermelho2 from '../../Images/ImgRiscoVermelho2.png';
import ImgRiscoVermelho2Resp from '../../Images/ImgRiscoVermelho2Resp.png';
import ImgBuffet from '../../Images/ImgBuffet.jpg';

function Banner() {
  const [data, setData] = useState<any>([]);
  const [load, setLoad] = useState(false);

  const loadData = () => {
    setLoad(true);
    useData()
      .getData('/api/buffet.php')
      .then((response: any) => {
        setLoad(false);
        setData(response);
      })
      .catch((err) => {
        console.info(err);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      loadData();
    }, 1000);
  }, []);

  return (
    <>
      {/* {load == true && <Load status={load} colorPrimary={'#c73127'} colorSecondary={'#b9b9b9'} />} */}

      {data &&
        data.map((data: any, index: React.Key | null | undefined) => (
          <>
            <div className='Ancora' id='Buffet'></div>
            <S.ForaBuffet key={index}>
              <S.ForaTextBuffetResp>
                <S.DentroForaTextBuffet>
                  <S.TextBuffet1>
                    <span>Buffet</span>
                  </S.TextBuffet1>
                  <S.TextBuffet1>próprio </S.TextBuffet1>
                  <S.TextBuffet1>e exclusivo</S.TextBuffet1>
                </S.DentroForaTextBuffet>
                <S.ImagemRiscoVermelho2 src={ImgRiscoVermelho2Resp} />
              </S.ForaTextBuffetResp>

              <S.ForaImagemBuffet>
                <S.ImagemBuffet
                  src={
                    'http://www.gruposaopauloeventos.com.br/espacounimed/upload/buffet/' +
                    data.id_tb_buffet +
                    'a.' +
                    data.c_extensao1
                  }
                />
              </S.ForaImagemBuffet>

              <S.DirBuffet>
                <S.ForaTextBuffet>
                  <S.TextBuffet1>
                    <span>Buffet</span> próprio e exclusivo
                  </S.TextBuffet1>
                  <S.ImagemRiscoVermelho2 src={ImgRiscoVermelho2} />
                </S.ForaTextBuffet>
                <S.TextBuffet2>{ReactHtmlParser(data.c_texto)}</S.TextBuffet2>
              </S.DirBuffet>
            </S.ForaBuffet>
          </>
        ))}
    </>
  );
}

export default Banner;
